import { css, FlattenSimpleInterpolation } from 'styled-components';

import { minWidth } from './mediaQueries';

// Sizes are in rem, with pixel translations for mobile and not-mobile in comments
export const FontSizes = {
	sm: 0.75, // 12px / 13.5px / small
	base: 1, // 16px / 18px / headline / body
	lg: 1.25, // 20px / 22.5px / title2
	xl: 1.5, // 24px / 27px // TODO: potentially deprecate
	'2xl': 1.75, // 28px / 31.5px / title1
	'3xl': 2.25, // 36px / 40.5px // TODO: potentially deprecate
	'4xl': 2.75, // 44px / 49.5px / hero
} as const;
export type FontSizeName = keyof typeof FontSizes;
export type FontSize = (typeof FontSizes)[FontSizeName];

// Font sizes that shift in rem value on mobile devices
const MobileFontSizes: Record<FontSizeName, number | undefined> = {
	sm: undefined,
	base: undefined,
	lg: undefined,
	xl: undefined,
	'2xl': 1.5,
	'3xl': undefined,
	'4xl': undefined,
} as const;

export const fontSize = (size: FontSize): FlattenSimpleInterpolation => {
	const fontSizeKey = (Object.keys(FontSizes) as FontSizeName[]).find(k => FontSizes[k] === size);
	const mobileFontSizeValue = fontSizeKey ? MobileFontSizes[fontSizeKey] : undefined;

	return css`
		font-size: ${mobileFontSizeValue ?? size}rem;
		${minWidth('mobileLarge')} {
			font-size: ${size * 1.125}rem;
		}
	`;
};

// These line heights are the closest to our "usual" 1.5 that put R18 fonts on an 8px grid
export const R18LineHeightsByFontSize: Record<FontSize, string> = {
	[FontSizes.sm]: '20px',
	[FontSizes.base]: '28px',
	[FontSizes.lg]: '32px',
	[FontSizes.xl]: '40px',
	[FontSizes['2xl']]: '48px',
	[FontSizes['3xl']]: '60px',
	[FontSizes['4xl']]: '72px',
} as const;
export const lineHeight = (size: FontSize): FlattenSimpleInterpolation => css`
	line-height: 150%;
	${minWidth('mobileLarge')} {
		line-height: ${R18LineHeightsByFontSize[size]};
	}
`;

export const FontWeights = {
	Light: 300,
	Regular: 400,
	Medium: 500,
	Demi: 700,
} as const;
export type FontWeight = (typeof FontWeights)[keyof typeof FontWeights];

export const fontWeight = (weight: FontWeight): FlattenSimpleInterpolation => css`
	font-weight: ${weight};
`;

export const fontFamily = css`
	font-family: 'Figtree', 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
`;

export const themeFontFamily = (fontFamily: string): FlattenSimpleInterpolation => css`
	font-family: ${fontFamily}, 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif;
`;
